<template>
  <div class="DListHeader">
    <DListTitle
      :title="item.name"
      :icon-type="THREE_D.LIST[idx].iconType"
      :isATitle="true"
      :aHref="PAGE_PATH.BASE_URL + PAGE_PATH.TU_PIAN.LIST + '/0-4-0-0-'+ item.id +'-'+ 0 +'-0-default-1.html' "
    >
      <DListClassify
        slot="classify"
        :classify-list="item.childs"
        v-on="$listeners"
        :classifyId="item.classifyId"
      />
    </DListTitle>
  </div>
</template>

<script>
import DListTitle from '@/components/3d/d-list/d-list-title'
import DListClassify from '@/components/3d/d-list/d-list-classify'
import {THREE_D} from "@/constant/3d/3D";
import {PAGE_PATH} from '@/constant/PAGE_PATH'

export default {
  name: "DListHeader",
  components:{
    DListTitle,
    DListClassify
  },
  props:{
    item:{
      type: Object,
      default:()=>{}
    },
    idx:{
      type: Number,
      default:0
    }
  },
  data(){
    return{
      THREE_D,
      PAGE_PATH
    }
  }
}
</script>

<style lang="scss" scoped>
.DListHeader{
  display: flex;
  align-items: center;

  .icon{
    &.hot{
      @include BgImage(39px,46px,'3d/icon_hot.png');
      margin-right: 20px;
    }
    &.topic{
      @include BgImage(56px,41px,'3d/icon_topic.png');
      margin-right: 20px;
    }


    &.business{
      @include BgImage(20px,20px,'3d/icon_business.png');
    }
    &.ele{
      @include BgImage(20px,20px,'3d/icon_ele.png');
    }

    &.person{
      @include BgImage(20px,20px,'3d/icon_person.png');
    }
    &.poster{
      @include BgImage(20px,20px,'3d/icon_poster.png');
    }
    &.scene{
      @include BgImage(20px,20px,'3d/icon_scene.png');
    }

  }

  .title-box{
    font-size: 32px;
    font-weight: bold;
    color: #2D2B33;
    line-height: 42px;
    letter-spacing: 1px;
  }
}
</style>


